import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { v4 as uuidv4 } from "uuid";

import { FaEnvelope } from "@react-icons/all-files/fa/FaEnvelope";
import { FaPhoneAlt } from "@react-icons/all-files/fa/FaPhoneAlt";
import { FaRegClock } from "@react-icons/all-files/fa/FaRegClock";
import { FaMapMarkerAlt } from "@react-icons/all-files/fa/FaMapMarkerAlt";

import Seo from "/src/components/Seo";
import Layout from "/src/components/Layout";
import AboutTeam from "/src/components/About/AboutTeam";

import "/src/css/about.css";
import "/src/css/contact.css";

const ContactPage = () => {
  const contactData = [
    {
      field: "Email",
      value: "chuxian@mgrium.com/ shu@mgrium.com",
      component: () => <FaEnvelope />,
    },
    {
      field: "Call Us",
      value: "+65 9170 2264",
      component: () => <FaPhoneAlt />,
    },
    {
      field: "Business Hours",
      value: "08 00 - 18 00",
      component: () => <FaRegClock />,
    },
    {
      field: "Location",
      value: "24 Senoko Avenue",
      component: () => <FaMapMarkerAlt />,
    },
  ];
  return (
    <div className="about-page">
      <Seo title="Contact Us" />
      <div className="about-team">
        <h1>Our Team</h1>
        <AboutTeam />
      </div>
      <div className="info">
        {contactData.map((elem) => (
          <div key={uuidv4()} className="contact">
            <div className="contact-image">{elem.component()}</div>
            <div className="contact-text">
              <header>{elem.field}</header>
              <h1 style={{ textAlign: "left" }}>{elem.value}</h1>
            </div>
          </div>
        ))}
      </div>
      <div className="about-signup">
        <Link to="/volunteer">
          <div className="about-signup-btn">
            <h3>Join Us Today!</h3>
            <StaticImage
              placeholder="tracedSVG"
              alt="A healthy Earth"
              src="../images/about-kittyhero.png"
              height={80}
              className="about-signup-img"
            />
          </div>
        </Link>
      </div>
    </div>
  );
};

ContactPage.Layout = Layout;
export default ContactPage;
